import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.5 14L13.1666 12.3333L11.5 10.6667M3.83329 2L2.16663 3.66667L3.83329 5.33333M2.33329 3.66667H12.3333C12.7015 3.66667 13 3.96514 13 4.33333V7M2.33329 9V11.6667C2.33329 12.0349 2.63177 12.3333 2.99996 12.3333H13",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }